import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toggleSchoolActiveThunk } from "../../store/reducers/schools/schools.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/reducers/schools/schools.reducer";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleSchoolId, toggling } = useSelector(
    (state) => state.schools,
  );

  const school = useSelector((state) =>
    state.schools.list.find((s) => s.id === toggleSchoolId),
  );

  const handleConfirm = () => {
    dispatch(toggleSchoolActiveThunk(toggleSchoolId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando escuela..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{school?.is_active ? "desactivar" : "activar"}</strong> la
            escuela <strong>{school?.nombre}</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>

            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleModal;
